import { ACTIONS } from '../constants/orders';
import { MODE } from '../constants/mode';

const INITIAL_STATE = {
  ordersList: { orders: [], params: {}, pager: null, error: null, loading: false },
  ordersByService: { orders: [], params: {}, pager: null, error: null, loading: false },
  activeOrder: { order: null, error: null, mode: null, loading: false },
  orderStatuses: { statuses: [], error: null, loading: false },
  orderComplete: { order: null, error: null, loading: false },
  orderCustomerApprovalLink: { order: null, error: null, loading: false },
  orderPaymentLink: { order: null, error: null, loading: false, mode: null },
};

export const orders = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.ORDER_CREATE_RESET:
    case ACTIONS.ORDER_UPDATE_RESET:
    case ACTIONS.ORDER_DELETE_RESET:
    case ACTIONS.ORDER_FETCH_RESET:
      return {
        ...state,
        activeOrder: {
          order: null,
          loading: false,
          error: null,
          mode: null,
        },
      };

    case ACTIONS.ORDER_CREATE_START:
      return {
        ...state,
        activeOrder: {
          order: action.payload,
          loading: true,
          error: null,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.ORDER_CREATE_FAILURE:
      return {
        ...state,
        activeOrder: {
          order: null,
          loading: false,
          error: action.payload,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.ORDER_CREATE_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.concat(action.payload),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.CREATE,
        },
      };

    case ACTIONS.ORDER_UPDATE_START:
      return {
        ...state,
        activeOrder: {
          order: action.payload,
          loading: true,
          error: null,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.ORDER_UPDATE_FAILURE:
      return {
        ...state,
        activeOrder: {
          order: null,
          loading: false,
          error: action.payload,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        ordersByService: {
          ...state.ordersByService,
          orders: state.ordersByService.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.UPDATE,
        },
      };

    case ACTIONS.ORDER_DELETE_START:
      return {
        ...state,
        activeOrder: {
          order: action.payload,
          loading: true,
          error: null,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.ORDER_DELETE_FAILURE:
      return {
        ...state,
        activeOrder: {
          order: null,
          loading: false,
          error: action.payload,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.ORDER_DELETE_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.filter(order => order.id !== action.payload.id),
          error: null,
          loading: false,
        },
        ordersByService: {
          ...state.ordersByService,
          orders: state.ordersByService.orders.filter(order => order.id !== action.payload.id),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.DELETE,
        },
      };

    case ACTIONS.ORDER_FETCH_START:
      return {
        ...state,
        activeOrder: {
          order: action.payload,
          loading: true,
          error: null,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.ORDER_FETCH_FAILURE:
      return {
        ...state,
        activeOrder: {
          order: null,
          loading: false,
          error: action.payload,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.ORDER_FETCH_SUCCESS:
      return {
        ...state,
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
      };

    case ACTIONS.ORDERS_FETCH_START:
      return {
        ...state,
        ordersList: {
          orders: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDERS_FETCH_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: action.payload.results,
          pager: action.payload.paginator,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDERS_FETCH_FAILURE:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDERS_FETCH_RESET:
      return {
        ...state,
        ordersList: {
          orders: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDERS_BY_SERVICE_FETCH_START:
      return {
        ...state,
        ordersByService: {
          orders: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDERS_BY_SERVICE_FETCH_SUCCESS:
      const ordersByServiceResults =
        action.payload && action.payload.results
          ? action.payload.results
          : action.payload && action.payload.orders
          ? action.payload.orders
          : action.payload && action.payload.order
          ? [action.payload.order]
          : Array.isArray(action.payload)
          ? action.payload
          : action.payload && action.payload.id
          ? [action.payload]
          : [];
      return {
        ...state,
        ordersByService: {
          ...state.ordersByService,
          orders: ordersByServiceResults,
          pager: action.payload && action.payload.paginator ? action.payload.paginator : null,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDERS_BY_SERVICE_FETCH_FAILURE:
      return {
        ...state,
        ordersByService: {
          ...state.ordersByService,
          orders: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDERS_BY_SERVICE_FETCH_RESET:
      return {
        ...state,
        ordersByService: {
          orders: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDER_STATUSES_FETCH_START:
      return {
        ...state,
        orderStatuses: {
          statuses: [],
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDER_STATUSES_FETCH_SUCCESS:
      return {
        ...state,
        orderStatuses: {
          statuses: action.payload,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDER_STATUSES_FETCH_FAILURE:
      return {
        ...state,
        orderStatuses: {
          statuses: [],
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDER_STATUSES_FETCH_RESET:
      return {
        ...state,
        orderStatuses: {
          statuses: [],
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDER_COMPLETE_START:
      return {
        ...state,
        orderComplete: {
          order: action.payload,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDER_COMPLETE_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        ordersByService: {
          ...state.ordersByService,
          orders: state.ordersByService.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
        orderComplete: {
          order: action.payload,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDER_COMPLETE_FAILURE:
      return {
        ...state,
        orderComplete: {
          order: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDER_COMPLETE_RESET:
      return {
        ...state,
        orderComplete: {
          order: null,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDER_CUSTOMER_APPROVAL_LINK_START:
      return {
        ...state,
        orderCustomerApprovalLink: {
          order: action.payload,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDER_CUSTOMER_APPROVAL_LINK_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        ordersByService: {
          ...state.ordersByService,
          orders: state.ordersByService.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
        orderCustomerApprovalLink: {
          order: action.payload,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDER_CUSTOMER_APPROVAL_LINK_FAILURE:
      return {
        ...state,
        orderCustomerApprovalLink: {
          order: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDER_CUSTOMER_APPROVAL_LINK_RESET:
      return {
        ...state,
        orderCustomerApprovalLink: {
          order: null,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDER_PAYMENT_LINK_START:
      return {
        ...state,
        orderPaymentLink: {
          order: action.payload,
          error: null,
          loading: true,
          mode: action.payload && action.payload.mode ? action.payload.mode : null,
        },
      };
    case ACTIONS.ORDER_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        ordersList: {
          ...state.ordersList,
          orders: state.ordersList.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        ordersByService: {
          ...state.ordersByService,
          orders: state.ordersByService.orders.map(order => {
            if (order.id === action.payload.id) {
              order = action.payload;
            }
            return order;
          }),
          error: null,
          loading: false,
        },
        activeOrder: {
          order: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
        orderPaymentLink: {
          order: action.payload,
          error: null,
          loading: false,
          mode: state.orderPaymentLink.mode,
        },
      };
    case ACTIONS.ORDER_PAYMENT_LINK_FAILURE:
      return {
        ...state,
        orderPaymentLink: {
          order: null,
          error: action.payload,
          loading: false,
          mode: state.orderPaymentLink.mode,
        },
      };
    case ACTIONS.ORDER_PAYMENT_LINK_RESET:
      return {
        ...state,
        orderPaymentLink: {
          order: null,
          error: null,
          loading: false,
          mode: null,
        },
      };

    default:
      return state;
  }
};
